(function ($) {
    $(function () {
        var sideNav = $('.sidebar .subnav__list');
        var subNav = $('.sidebar .subnav__sub-list');

        subNav.addClass('subnav__sub-list--hidden');

        $('.sub-list__list').addClass('sub-list__list--hidden');
        $('.subnav__sub-item--tertiary-nav-wrapper').find('.sub-list__list').addClass('sub-list__list--hidden');

        $('.subnav__icon--clickable').each(function () {

            $(this).on('click', function (e) {

                e.preventDefault();

                $(this).toggleClass('subnav__icon--active');

                var subMenu = $(this).parent('li a').next('.subnav__sub-list');

                subMenu.toggleClass('subnav__sub-list--hidden');

            });
        });

        // Sub-list list
        $('.subnav__sub-link--tertiary-parent .icon--clickable').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();

                $(this).toggleClass('icon--active');

                var subListList = $(this).parent().next('ul');

                subListList.toggleClass('sub-list__list--hidden');
            });
        });

        $('.subnav__sub-item--tertiary-nav-wrapper').each(function () {
            var icon = $(this).find('.icon--clickable');
            var submenu = $(this).find('.sub-list__list--tertiary-sub-list');

            icon.on('click', function (e) {
                e.preventDefault();

                $(this).toggleClass('icon--active-active');

                submenu.toggleClass('sub-list__list--hidden');
            });
        });

        // We need to ensure that if a second level category is the active category,
        // or a first - level category with children is active, then the second
        // level list of categories shown on load
        $('.subnav__sub-item--force-parent-open').closest('.subnav__sub-list').removeClass('subnav__sub-list--hidden');
        // $('.subnav__sub-item--force-parent-open').closest('.subnav__item').addClass('subnav__item--active');
        $('.subnav__sub-item--force-parent-open').closest('.subnav__item').addClass('subnav__item--stays-open');

        $('.subnav__item--stays-open').find('.subnav__sub-list').removeClass('subnav__sub-list--hidden');
        $('.subnav__item--stays-open').filter('.subnav__sub-item--active').find('.sub-list__list').not('.sub-list__list--tertiary-sub-list').removeClass('sub-list__list--hidden');
        $('.subnav__item--stays-open').find('.subnav__icon--clickable').addClass('subnav__icon--active');
        $('.subnav__item--stays-open').filter('.subnav__sub-item--active').find('.icon--clickable').addClass('icon--active');
        $('.subnav__sub-item--tertiary-nav-wrapper.subnav__item--stays-open').find('.sub-list__list--tertiary-sub-list').removeClass('sub-list__list--hidden');
        $('.subnav__sub-item--tertiary-nav-wrapper.subnav__item--stays-open').find('.icon--clickable').addClass('icon--active-active');
        $('.subnav__sub-item--tertiary-nav-wrapper.subnav__item--stays-open').parents('.sub-list__list').removeClass('sub-list__list--hidden');
        $('.subnav__sub-item--tertiary-nav-wrapper.subnav__item--stays-open').parents('.subnav__sub-item ').find('.icon--clickable').addClass('icon--active');
    });
})(jQuery);